import { useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";

export const ReviewText = ({ r }) => {
  const { user, setAuthOpen } = useAuth();
  const { lang } = useLanguage();
  const fr = lang === "fr";
  const [tr, setTr] = useState(null);
  const [busy, setBusy] = useState(false);
  const [showOrig, setShowOrig] = useState(false);
  if (!r.comment) return null;
  const active = tr && tr.lang === lang ? tr.text : null;

  const translate = async () => {
    if (!user) return setAuthOpen(true);
    setBusy(true);
    try {
      const { data } = await api.post(`/reviews/${r.id}/translate?lang=${lang}`);
      if (data.same) toast(fr ? "Cet avis est déjà en français" : "This review is already in English");
      else { setTr(data); setShowOrig(false); }
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  const btn = "inline-flex items-center gap-1 text-xs font-semibold text-slate-400 hover:text-[#F5551E] transition-colors";
  return (
    <div className="mt-3">
      <p className="text-slate-600 text-sm whitespace-pre-line" data-testid={`review-text-${r.id}`}>{active || r.comment}</p>
      {active && showOrig && <p className="mt-2 text-xs italic text-slate-400 whitespace-pre-line border-l-2 border-slate-200 pl-2" data-testid={`review-original-${r.id}`}>{r.comment}</p>}
      <div className="mt-2 flex items-center gap-3">
        {active ? (
          <>
            <span className="text-[11px] text-slate-400 inline-flex items-center gap-1" data-testid={`review-translated-${r.id}`}>
              <Languages size={11} /> {fr ? "Traduit automatiquement" : "Translated automatically"}
            </span>
            <button type="button" onClick={() => setShowOrig((v) => !v)} className={btn} data-testid={`review-original-toggle-${r.id}`}>
              {showOrig ? (fr ? "Masquer l'original" : "Hide original") : (fr ? "Voir l'original" : "Show original")}
            </button>
          </>
        ) : (
          <button type="button" onClick={translate} disabled={busy} className={btn} data-testid={`review-translate-btn-${r.id}`}>
            {busy ? <Loader2 size={12} className="animate-spin" /> : <Languages size={12} />} {fr ? "Traduire" : "Translate"}
          </button>
        )}
      </div>
    </div>
  );
};
